<template>
<div class="filter-content">
  <span>
    <v-menu
      :close-on-content-click="false"
      offset-y
      max-height="300px"
      min-width="300px"
      content-class="menu-filter-content"
    >
      <template v-slot:activator="{ on : menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on : tooltip }">
            <v-btn
              dark
              color="orange"
              v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>filter_list</v-icon>
            </v-btn>
          </template>
          <span>Фильтр</span>
        </v-tooltip>

      </template>
      <v-list class="filter-menu" @keyup.native.enter="goFilter">
        <v-list-item dense>
          <span class="filter-buttons filter-text">
            Фильтр
          </span>
          <v-spacer></v-spacer>
          <span class="filter-buttons filter-text">
            {{ count }} / {{ countTotal }}
          </span>
        </v-list-item>

        <!-- fields start -->
        <v-list-item>
          <Date
            v-model="query.date"
            label="Дата"
            :required="false"
            :clearable="true"
            :left="300"
          />
        </v-list-item>

        <!-- fields end -->
        <v-list-item>
          <v-spacer></v-spacer>
          <span class="filter-buttons">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  color="orange"
                  v-on="on"
                  @click="resetFilter"
                >
                <i class="fas fa-ban fa-lg"></i>
                </v-btn>
              </template>
              <span>Сбросить</span>
            </v-tooltip>
          </span>

          <span class="filter-buttons">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="filterPending"
                  dark
                  color="orange"
                  v-on="on"
                  @click="goFilter"
                >
                <i class="fas fa-search fa-lg"></i>
                </v-btn>
              </template>
              <span>Поиск</span>
            </v-tooltip>
          </span>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</div>
</template>

<script>
import { removeNulls } from '@/utils'
import FilterMixin from '@/components/filters/Filter.vue'

export default {
  mixins: [FilterMixin],
  props: {
  },
  data: function () {
    return {
    }
  },
}
</script>
<style scoped>
</style>
